import { changePassword } from '@/services/auth.service'
import vue from 'vue'

export default {
  data: () => ({
    newPassword1: null,
    newPassword2: null,
    currentPassword: null,
    valid: true
  }),

  methods: {
    handlePasswordChange(options = {}) {
      const { redirectAfterSuccess = true, closeDialog = null } = options

      if (this.$refs.form && !this.$refs.form.validate()) {
        return false
      }

      const uid = this.$route?.params?.uid
      const token = this.$route?.params?.token

      console.log('uid, token :>> ', uid, token, this.newPassword1, this.newPassword2);
      const promise = uid && token
        ? changePassword(this.newPassword1, this.newPassword2, uid, token)
        : changePassword(this.newPassword1, this.newPassword2)

      promise
        .then(response => {
          vue.$log.info('Password changed successfully', response)

          // Show success notification with message from server
          const successMessage = response?.detail || response?.message || 'Hasło zostało pomyślnie zmienione'
          this.$dialog.notify.success(successMessage, {
            timeout: 5000
          })

          // Trigger password manager save prompt by creating a temporary form
          this.triggerPasswordSave()

          if (closeDialog) {
            // Delay closing dialog to allow password manager to detect the change
            setTimeout(() => {
              closeDialog()
            }, 500)
          }

          if (redirectAfterSuccess) {
            setTimeout(() => {
              this.$router.push({ name: 'Home' })
            }, 500)
          }
        })
        .catch(error => {
          console.log('error :>> ', error.response)
          const data = error.response?.data

          if (data == null) {
            return
          }

          if (data.token) {
            this.$dialog.notify.error('Link jest już nieważny', {
              timeout: 10000
            })
          } else if (data.new_password2) {
            for (const message of data.new_password2) {
              this.$dialog.notify.error(message , {
                timeout: 10000
              })
            }
          }

          vue.$log.error(`Password change error: ${error}`)
        })

      return false
    },

    triggerPasswordSave() {
      // Create a hidden form to trigger browser's password save prompt
      const form = document.createElement('form')
      form.method = 'post'
      form.action = window.location.href
      form.style.display = 'none'

      const usernameInput = document.createElement('input')
      usernameInput.type = 'text'
      usernameInput.name = 'username'
      usernameInput.autocomplete = 'username'
      usernameInput.value = this.$store.state.auth?.user?.email || this.$store.state.auth?.user?.username || ''

      const passwordInput = document.createElement('input')
      passwordInput.type = 'password'
      passwordInput.name = 'password'
      passwordInput.autocomplete = 'current-password'
      passwordInput.value = this.newPassword1

      form.appendChild(usernameInput)
      form.appendChild(passwordInput)
      document.body.appendChild(form)

      // Trigger form submission detection
      setTimeout(() => {
        document.body.removeChild(form)
      }, 1000)
    }
  }
}
